<template>
  <div>
    <navbar></navbar>
    <div
      style="
        background: #f9f9fb 0% 0% no-repeat padding-box;
        opacity: 1;
        height: auto;
        min-height: 100vh;
        margin-top: 50px;
      "
    >
      <!-- <side-bar></side-bar> -->
      <div class="container-fluid pl-0 pr-0">
        <div
          class="row mr-0 ml-0"
          style="padding-left: 30px; padding-right: 30px; padding-top: 20px"
        >
          <div
            class="d-flex w-100"
            style="
              margin-bottom: 25px;
              justify-content: space-between;
              padding-right: 20px;
              padding-left: 5px;
            "
          >
            <div
              class="company-profile-people-more-less"
              @click="goToDashboard"
              style="padding-top: 5px"
            >
              {{ backText }}
            </div>

            <button
              class="newTask"
              v-if="showAddToDiligenceButton"
              @click="diligenceModal = true"
            >
              Add to Diligence
            </button>
            <!-- <div class="addtoDiligenceLayout" @click="diligenceModal=true" style="cursor:pointer">
              <div class="addToDiligenceText">Add to Diligence</div>
            </div>-->
          </div>

          <div class="row mr-0 ml-0 w-100" style>
            <div class="col-md-3 borderClass">
              <div style="padding-left: 15px; padding-right: 15px">
                <div
                  class="d-flex company-profile-top"
                  style="padding-top: 45px"
                >
                  <div class="company-profile-top-parent">
                    <div
                      :style="statusBadge.style"
                      class="company-profile-badge"
                    >
                      <span class="companyProfileStatusBadgeValue">{{
                        statusBadge.value
                      }}</span>
                    </div>
                    <span style="flex: 1 1 auto"></span>
                  </div>
                  <div class="flex-grow-1" style="text-align: center">
                    <img
                      :src="getCompanyImageUrl"
                      class="rounded-circle"
                      style="width: 120px; height: 120px"
                    />
                  </div>
                </div>
                <div style="text-align: center">
                  <div class="company-profile-name">{{ company.name }}</div>
                  <div class="company-profile-sector">
                    {{ filterCategoryData }}
                  </div>
                </div>
                <div style="padding-bottom: 20px" class>
                  <table class="portfolio-company-left-table-data">
                    <tr v-for="field in companyTableFields" :key="field.label">
                      <th>{{ field.label }}</th>
                      <td>
                        <span
                          style="
                            line-height: 1.5;
                            display: inline-block;
                            max-width: 100%;
                          "
                          v-html="field.value"
                          >{{}}</span
                        >
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
            <div class="col-md-9 borderClass">
              <div
                class="row mr-0 ml-0"
                style="padding-left: 9px; padding-right: 9px; padding-top: 45px"
              >
                <div>
                  <div class="companyDescriptionTitle">Company Description</div>
                  <div class="companyDescriptionData">
                    {{ company.description }}
                  </div>
                </div>
                <div class="col-md-12 pl-0 pr-0" style="margin-top: 20px">
                  <div
                    id="fundingRounds"
                    class="todos-table-parent companyProfileTabulatorLayout"
                  >
                    <div class>
                      <div class="sharedProfileTabulatorTitle">
                        Funding Rounds
                      </div>
                      <div class="sharedProfileTabulatorTitleBorderLine"></div>
                    </div>
                    <div id="fundingRoundsTable">
                      <div class="tabulator" ref="fundingRoundsTable"></div>
                    </div>
                  </div>
                </div>
                <div
                  class="col-md-3 pl-0 pr-0"
                  style="margin-top: 12px; margin-bottom: 20px"
                >
                  <div class="contactsTitle" v-if="founders.length > 0">
                    Founders
                  </div>
                  <div
                    class="contactsTitle"
                    v-if="founders.length == 0"
                    style="color: #676767 !important"
                  >
                    Founders
                  </div>
                  <div v-if="founderArray && founderArray.length > 0">
                    <div
                      class="d-flex"
                      style="padding-bottom: 10px"
                      v-for="(item, index) in founderArray"
                      :key="index"
                    >
                      <div style="padding-right: 8px">
                        <img
                          v-bind:src="getPeopleImageUrl(item)"
                          width="20"
                          height="20"
                          class="rounded-circle"
                        />
                      </div>
                      <div class="contactsName">{{ item.name }}</div>
                    </div>
                    <div
                      v-if="founders.length > 2 && founderArray.length == 2"
                      class="company-profile-people-more-less"
                      @click="contactClick('founder', 'more')"
                    >
                      {{ founders.length - 2 }} more
                    </div>
                    <div
                      v-if="founders.length > 2 && founderArray.length > 2"
                      class="company-profile-people-more-less"
                      @click="contactClick('founder', 'less')"
                    >
                      Show less
                    </div>
                  </div>
                </div>
                <div
                  class="col-md-3 pl-0 pr-0"
                  style="margin-top: 12px; margin-bottom: 20px"
                >
                  <div
                    class="contactsTitle"
                    v-if="
                      investors[0] &&
                      investors[0].list &&
                      investors[0].list.length > 0
                    "
                  >
                    Investors
                  </div>
                  <div
                    class="contactsTitle"
                    v-if="
                      investors[0] &&
                      investors[0].list &&
                      investors[0].list.length == 0
                    "
                    style="color: #676767 !important"
                  >
                    Investors
                  </div>
                  <div v-if="investorArray && investorArray.length > 0">
                    <div
                      class="d-flex"
                      style="padding-bottom: 10px"
                      v-for="(item, index) in investorArray"
                      :key="index"
                    >
                      <div style="padding-right: 8px">
                        <img
                          v-bind:src="getPeopleImageUrl(item)"
                          width="20"
                          height="20"
                          class="rounded-circle"
                        />
                      </div>
                      <div class="contactsName">{{ item.investor_name }}</div>
                    </div>
                    <div
                      v-if="
                        investors[0] &&
                        investors[0].list &&
                        investors[0].list.length > 2 &&
                        investorArray.length == 2
                      "
                      class="company-profile-people-more-less"
                      @click="contactClick('investor', 'more')"
                    >
                      {{
                        investors[0] &&
                        investors[0].list &&
                        investors[0].list.length - 2
                      }}
                      more
                    </div>
                    <div
                      v-if="
                        investors[0] &&
                        investors[0].list &&
                        investors[0].list.length > 2 &&
                        investorArray.length > 2
                      "
                      class="company-profile-people-more-less"
                      @click="contactClick('investor', 'less')"
                    >
                      Show less
                    </div>
                  </div>
                </div>
                <div
                  class="col-md-3 pl-0 pr-0"
                  style="margin-top: 12px; margin-bottom: 20px"
                >
                  <div class="contactsTitle" v-if="advisors.length > 0">
                    Advisors
                  </div>
                  <div
                    class="contactsTitle"
                    v-if="advisors.length == 0"
                    style="color: #676767 !important"
                  >
                    Advisors
                  </div>
                  <div v-if="advisorArray && advisorArray.length > 0">
                    <div
                      class="d-flex"
                      style="padding-bottom: 10px"
                      v-for="(item, index) in advisorArray"
                      :key="index"
                    >
                      <div style="padding-right: 8px">
                        <img
                          v-bind:src="getPeopleImageUrl(item)"
                          width="20"
                          height="20"
                          class="rounded-circle"
                        />
                      </div>
                      <div class="contactsName">{{ item.person_name }}</div>
                    </div>
                    <div
                      v-if="advisors.length > 2 && advisorArray.length == 2"
                      class="company-profile-people-more-less"
                      @click="contactClick('advisor', 'more')"
                    >
                      {{ advisors.length - 2 }} more
                    </div>
                    <div
                      v-if="advisors.length > 2 && advisorArray.length > 2"
                      class="company-profile-people-more-less"
                      @click="contactClick('advisor', 'less')"
                    >
                      Show less
                    </div>
                  </div>
                </div>
                <div
                  class="col-md-3 pl-0 pr-0"
                  style="margin-top: 12px; margin-bottom: 20px"
                >
                  <div class="contactsTitle" v-if="employees.length > 0">
                    Employees
                  </div>
                  <div
                    class="contactsTitle"
                    v-if="employees.length == 0"
                    style="color: #676767 !important"
                  >
                    Employees
                  </div>
                  <div v-if="employeeArray && employeeArray.length > 0">
                    <div
                      class="d-flex"
                      style="padding-bottom: 10px"
                      v-for="(item, index) in employeeArray"
                      :key="index"
                    >
                      <div style="padding-right: 8px">
                        <img
                          v-bind:src="getPeopleImageUrl(item)"
                          width="20"
                          height="20"
                          class="rounded-circle"
                        />
                      </div>
                      <div class="contactsName">{{ item.name }}</div>
                    </div>
                    <div
                      v-if="employees.length > 2 && employeeArray.length == 2"
                      class="company-profile-people-more-less"
                      @click="contactClick('employee', 'more')"
                    >
                      {{ employees.length - 2 }} more
                    </div>
                    <div
                      v-if="employees.length > 2 && employeeArray.length > 2"
                      class="company-profile-people-more-less"
                      @click="contactClick('employee', 'less')"
                    >
                      Show less
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- checlist section -->

          <div class="mr-0 ml-0 w-100" style="margin-top: 25px; margin-bottom: 25px" v-if="portfolioChecklist && portfolioChecklist.length">
              <div class="col-md-12 pl-0 pr-0">
                <div
                  id="fundingRounds"
                  class="todos-table-parent companyProfileTabulatorLayout fundingRoundsLayout"
                >
                  <div class>
                    <div class="companyProfileTabulatorTitle">Checklist</div>
                    <!-- <div class="companyProfileTabulatorTitleBorderLine">{{checklist.name}}</div> -->
                  </div>
                  <div>
                    <div>
                      <div
                      v-for="(checklist, idx) in portfolioChecklist"
                    :key="idx"
                    style="margin-top: 20px;"
                    >
                        <div class="checklist-name">{{checklist.name}}</div>
                        <div class="checklist-description">
                          {{checklist.description}}
                        </div>
                        <div 
                        v-for="(item, idx2) in checklist.checklist_items"
                    :key="idx2">
                          <div
                            class="flex-row"
                            style="
                              display: flex;
                              margin-top: 15px;
                              margin-bottom: 10px;
                            "
                          >
                          <div style="margin-top: 1px">
                            <i class="fa fa-square-o" v-if="!item.is_done"></i>
                            <i class="fa fa-check-square" v-if="item.is_done"></i>
                          </div>
                            <div v-html="item.summary" class="task"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
      <el-dialog
        left
        title="Add To Diligence"
        :closeOnClickModal="false"
        :closeOnPressEscape="false"
        :showClose="true"
        width="403px"
        style="margin: 0 auto"
        :visible.sync="diligenceModal"
        @close="(selectedWorkspaceId = ''), (isSubmit = false)"
        class="addToDiligenceMdl col-lg-12 col-sm-12 col-12 col-md-12"
      >
        <form @submit.prevent="addToDiligence">
          <div class="row">
            <div class="col-12">
              <label>Workspace</label>
              <b-form-select
                v-model="selectedWorkspaceId"
                class="mb-3"
                placeholder="Select Workspace"
              >
                <b-form-select-option-group label="Personal Workspace">
                  <b-form-select-option
                    v-for="item in myWorkspaces"
                    :key="item.workspace_id"
                    class="form-control py-2"
                    :value="item.workspace_id"
                    >{{ item.workspace_title }}</b-form-select-option
                  >
                </b-form-select-option-group>
                <b-form-select-option-group
                  v-if="sharedWorkspace.length > 0"
                  label="Shared Workspace"
                >
                  <b-form-select-option
                    v-for="item in sharedWorkspace"
                    :key="item.workspace_id"
                    class="form-control py-2"
                    :value="item.workspace_id"
                    >{{ item.workspace_title }}</b-form-select-option
                  >
                </b-form-select-option-group>
              </b-form-select>
              <!-- <select name="cars" id="cars" class="form-control team-form">
              <optgroup class="form-control" label="Personal">
                <option
                  v-for="item in myWorkspaces"
                  :key="item.workspace_id"
                  class="form-control py-2"
                  :value="item.workspace_id"
                >{{item.workspace_title}}</option>
              </optgroup>
              <optgroup v-if="sharedWorkspace.length>0" class="form-control" label="Shared">
                <option
                  v-for="item in sharedWorkspace"
                  :key="item.workspace_id"
                  class="form-control"
                  :value="item.workspace_id"
                >{{item.workspace_title}}</option>
              </optgroup>
              </select>-->
            </div>
          </div>
          <div class="edit-company-action-button-row py-3" style="margin: 0px">
            <button
              type="button"
              @click="
                selectedWorkspaceId = '';
                diligenceModal = false;
                isSubmit = false;
              "
              class="todo-form-cancel-button btn-outline-secondary"
            >
              Cancel
            </button>
            <button
              type="submit"
              :disabled="
                isSubmit ||
                (selectedWorkspaceId && selectedWorkspaceId.length <= 0)
              "
              class="todo-form-submit-button btn btn-primary"
              style="height: 35px"
            >
              Save
              <b-spinner
                v-if="isSubmit"
                style="float: right"
                small
                label="Loading..."
              ></b-spinner>
            </button>
          </div>
        </form>
      </el-dialog>
      <el-dialog
        left
        title
        :closeOnClickModal="false"
        :closeOnPressEscape="false"
        :showClose="false"
        width="300px"
        style="margin: 0 auto"
        :visible.sync="showLoader"
        class="loadingModal col-lg-12 col-sm-12 col-12 col-md-12"
      >
        <div style="text-align: center">
          <div>
            <b-spinner
              style="width: 7rem; height: 7rem; color: #5445f3"
              class="mt-5"
              label="Large Spinner"
            ></b-spinner>
          </div>
          <div style="margin-top: 15px; color: #000">Loading...</div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import config from "../../../../config/settings";
import Tabulator from "tabulator-tables";
import { Select, Option, Dialog } from "element-ui";
import { mapGetters } from "vuex";
import api from "../../../axios_api";
import NavbarNew from "../Layout/NavbarNew";
export default {
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    [Dialog.name]: Dialog,
    [NavbarNew.name]: NavbarNew,
  },
  data() {
    return {
      permalink: "",
      name: "",
      description: "",
      company: {},
      loginUrl: "",
      isSubmit: false,
      signupUrl: "",
      tabulator: null,
      advisorArray: [],
      founderArray: [],
      selectedWorkspaceId: "",
      employeeArray: [],
      investorArray: [],
      founders: [],
      advisors: [],
      investors: [],
      employees: [],
      referredBy: "",
      accountId: "",
      workspaceId: "",
      diligenceModal: false,
      showLoader: false,
      checkDataCount: 0,
      portfolioChecklist: []
    };
  },
  computed: {
    ...mapGetters("workspace", ["workspaces", "currentWorkspace"]),
    ...mapGetters("role", ["getCurrentWorkspaceRolePermissions", "checkRole"]),
    config() {
      return config;
    },
    workspacesData() {
      let data = JSON.parse(JSON.stringify(this.workspaces));
      data = data.filter((item) => {
        if (item.clientName && item.clientName._id) return item;
      });
      let result = _.chain(data)
        .groupBy("clientName._id")
        .map(function (v, i) {
          return {
            clientId: i,
            client_name:
              v[0].clientName.firstName != v[0].clientName.lastName
                ? `${v[0].clientName.firstName} ${v[0].clientName.lastName}`
                : v[0].clientName.firstName,
            account_workspace: _.map(v),
          };
        })
        .value();
      result.map((item) => {
        if (item.account_workspace) {
          item.account_workspace.map((workspaceItem) => {
            workspaceItem.workspace_id = workspaceItem.workspace._id;
            workspaceItem.workspace_title = workspaceItem.workspace.title
              ? workspaceItem.workspace.title
              : "Untitled";
            workspaceItem.workspace_type = workspaceItem.workspace
              .workspace_type
              ? workspaceItem.workspace.workspace_type
              : "";
          });
        }
      });
      return result;
    },
    myWorkspaces() {
      let data = this.workspacesData.find(
        (item) => item.clientId == this.$route.params.account_id
      );
      if (data) return data.account_workspace;
      else return [];
    },
    sharedWorkspace() {
      let data = [];
      let workspaces = this.workspacesData.filter(
        (item) => item.clientId != this.$route.params.account_id
      );
      workspaces.map((item) => {
        if (item.account_workspace) {
          item.account_workspace.map((item) => data.push(item));
        }
      });
      return data;
    },
    filterCategoryData() {
      if (this.company.category_data) {
        let categoryData = this.company.category_data;
        categoryData = categoryData.split(",");
        return Array.from(new Set(categoryData)).toString();
      } else {
        return;
      }
    },
    companyTableFields() {
      this.company.sector =
        this.company.sector == "" || this.company.sector == "Unknown"
          ? "-"
          : this.company.sector;
      this.company.stage_i_invested = this.company.stage_i_invested
        ? this.company.stage_i_invested
        : "-";
      this.company.founding_date = this.company.founding_date
        ? this.company.founding_date
        : "-";
      this.company.initial_investment = this.company.initial_investment
        ? this.company.initial_investment
        : "-";
      this.company.estimated_revenue_range =
        this.company.estimated_revenue_range || "-";
      this.company.direct = this.company.direct ? this.company.direct : "-";
      this.company.ipo_status = this.company.ipo_status
        ? this.company.ipo_status
        : "-";
      this.company.fund =
        this.company.fund || this.company.fund != "" ? this.company.fund : "-";
      this.company.status = this.company.status
        ? this.company.status
        : "Unknown";
      this.company.category_data = this.company.category_data
        ? this.company.category_data
        : "-";
      this.company.headquarters = this.company.headquarters
        ? this.company.headquarters
        : "-";
      this.company.geography =
        this.company.geography && this.company.geography != "Unspecified"
          ? this.company.geography
          : "-";
      this.company.website = this.company.website ? this.company.website : "-";
      this.company.facebook = this.company.facebook
        ? this.company.facebook
        : "-";
      this.company.linkedin = this.company.linkedin
        ? this.company.linkedin
        : "-";
      this.company.twitter = this.company.twitter ? this.company.twitter : "-";
      this.company.contact_email = this.company.contact_email
        ? this.company.contact_email
        : "-";
      this.company.lastFunding = this.company.last_funding_round
        ? this.company.last_funding_round
        : "-";
      return [
        {
          label: "Founding Date:",
          value:
            // this.company.founding_date &&
            // this.company.founding_date != "-" &&
            // this.company.founding_date != "Invalid date"
            //   ? moment(this.company.founding_date).format("MM/DD/YYYY")
            //   : "-",
            this.company.founding_date &&
            this.company.founding_date != "-" &&
            this.company.founding_date != "Invalid date"
              ? this.company.founding_date
              : "-",
          isEditOn: false,
          isEditable: false,
        },
        {
          label: "Geography:",
          value: this.company.geography,
          isEditOn: false,
          isEditable: false,
        },
        {
          label: "Headquarters:",
          value: this.company.headquarters,
          isEditOn: false,
          isEditable: false,
        },
        {
          label: "No. of Employees:",
          value: this.company.employee_count || "-",
          isEditOn: false,
          isEditable: false,
        },
        {
          label: "Website:",
          value:
            this.company.website && this.company.website != "-"
              ? `<a class="link" href="${this.company.website}" target="_blank">${this.company.website}</a>`
              : "-",
          isEditOn: false,
          isEditable: false,
        },
        {
          label: "Contact Email:",
          value:
            this.company.contact_email && this.company.contact_email != "-"
              ? `<a class="link" style="color: #0000009A;" href="mailto:${this.company.contact_email}">${this.company.contact_email}</a>`
              : "-",
          isEditOn: false,
          isEditable: false,
        },
        {
          label: "Social Media:",
          value: this.socialMedia,
          isEditOn: false,
          isEditable: false,
        },
      ];
    },
    socialMedia() {
      let html = "";
      if (
        (this.company.facebook && this.company.facebook != "-") ||
        (this.company.linkedin && this.company.linkedin != "-") ||
        (this.company.twitter && this.company.twitter != "-")
      ) {
        html = `<div class="d-flex">
          <div>
          <a class="link" href="${this.company.facebook}" target="_blank" style="color: #0000009A;font-size: 18px;padding-right: 5px;">
          <i class="fa fa-facebook-square" aria-hidden="true"></i>
          </a>
          </div>
           <div>
          <a class="link" href="${this.company.linkedin}" target="_blank" style="color: #0000009A;font-size: 18px;padding-right: 5px;">
          <i class="fa fa-linkedin-square" aria-hidden="true"></i>
          </a> 
          </div>
           <div>
          <a class="link" href="${this.company.twitter}" target="_blank" style="color: #0000009A;font-size: 18px;padding-right: 5px;">
          <i class="fa fa-twitter-square" aria-hidden="true"></i>
          </a>
          </div>
          </div>`;
      } else {
        html = `<div style="color:#0000009A;font-size:18px">-</div>`;
      }
      return html;
    },
    statusBadge() {
      let obj = {};
      this.company.company_status = this.company.company_status
        ? this.company.company_status
        : "Unknown";
      obj.value = this.company.company_status;
      if (
        this.company.company_status == "Active" ||
        this.company.company_status == "Unknown" ||
        this.company.company_status == "Mentor"
      ) {
        obj.style =
          "margin-top:2px;background: #CBF6C5 0% 0% no-repeat padding-box;border-radius: 10px;opacity: 1;";
      } else if (this.company.company_status == "Out of Business") {
        obj.value = "OB";
        obj.style =
          "margin-top:2px;background: #FACCCC 0% 0% no-repeat padding-box;border-radius: 10px;opacity: 1;";
      } else if (this.company.company_status == "IPO") {
        obj.style =
          "margin-top:2px;background: #FFDFB4 0% 0% no-repeat padding-box;border-radius: 10px;opacity: 1;";
      } else if (this.company.company_status == "Acquired") {
        obj.style =
          "margin-top:2px;background: #B4DCFF 0% 0% no-repeat padding-box;border-radius: 10px;opacity: 1;";
      } else {
        obj.style =
          "margin-top:2px;background: #FFDFB4 0% 0% no-repeat padding-box;border-radius: 10px;opacity: 1;";
      }
      return obj;
    },
    backText() {
      if (this.$route.query.diligence) return "Back to Diligence";
      else if (this.$route.query.back) return "Back to Workspace";
      else return "Back";
    },
    getCompanyImageUrl() {
      return this.company &&
        this.company.hasOwnProperty("image_id") &&
        this.company.image_id.length > 0
        ? `${config.CRUNCHBASE_IMAGE_URL}/${this.company.image_id}`
        : this.company.logo && this.company.logo.length > 0
        ? this.company.logo
        : "/static/img/generic-logo.png";
    },
    showAddToDiligenceButton() {
      if (!this.$route.query.workspace_id) {
        return true;
      }
      return this.showAddCompany();
    },
  },
  mounted() {
    this.mountedMethod();
    this.getChecklist();
  },
  methods: {
    async getChecklist() {
      if (!this.$route.query || !this.$route.query.c) {
        return;
      }
      
      let data = await fetch(`${config.API_URL}/checklist`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          data: {
            checklist_ids: this.$route.query.c
          },
        }),
      });

      let successData = await data.json();
      this.portfolioChecklist = successData.success;
    },
    sendDiligenceNotifications(data) {
      let self = this;
      if (this.checkRole && this.checkRole.toLowerCase() == "collaborator") {
        let name = this.company.name;
        setTimeout(() => {
          let activeDiligenceData = this.$store.getters[
            "diligence/activeDiligenceData"
          ];
          let diligenceData = activeDiligenceData.find(
            (item) => item.name == name
          );
          if (diligenceData) {
            let notificationPayload = {
              ucid: diligenceData.ucid,
              organization: diligenceData.organization,
              account_id: self.$route.params.account_id,
              workspace_id: diligenceData.workspace,
              name: diligenceData.name,
            };
            self.$store.dispatch(
              "notifications/apiDiligenceCollaboratorReceipt",
              {
                type: "suggestions",
                diligenceData: notificationPayload,
              }
            );
          }
        }, 2000);
      }
    },
    addToDiligence() {
      let self = this;
      this.isSubmit = true;
      let payload = {
        account_id: this.$route.params.account_id,
        workspace_id: this.selectedWorkspaceId,
        data_status: "Confirmed",
        direct: "Direct",
        cost: 0,
        value: 0,
        permalink: this.company.permalink ? this.company.permalink : "",
        geography: this.company.geography ? this.company.geography : "",
        logo_url: this.company.logo ? this.company.logo : "",
        name: this.company.name ? this.company.name : "",
      };
      if (this.$route.query.a) {
        payload.accountReferredBy = this.$route.query.a
          ? this.$route.query.a
          : this.referredBy;
      }
      api
        .post(
          `${payload.account_id}/${payload.workspace_id}/diligence/company`,
          { encrypt: { data: payload } }
        )
        .then((data) => {
        api.post(`/checklist`, {data: {
              checklist_ids: this.$route.query.c
            }}).then(res => {
              let checklists = res.data.success;
              for(let item of checklists){
                let checklist_data = {
                  portfolio_item: data.data.encrypt.success[0]._id,
                  name: item.name,
                  copiedChecklistItems: item.checklist_items
                }
                api.post(`${this.$route.params.account_id}/${this.selectedWorkspaceId}/${data.data.encrypt.success[0]._id}/checklist`, 
                { 
                  encrypt: { 
                    data: checklist_data 
                  }
                })
                  .then(res => {
                  })
                  .catch(err => {
                      console.error(`Error during checklist post: ${err}`)
                  })
              }
            })

          if (payload.accountReferredBy) {
            self.$store.dispatch("referrer/start");
          }
          if (
            data.data &&
            data.data.encrypt &&
            data.data.encrypt.fail &&
            data.data.encrypt.fail[0] &&
            data.data.encrypt.fail[0].error
          ) {
            this.$toaster.error(data.data.encrypt.fail[0].error.message);
            this.isSubmit = false;
            this.diligenceModal = false;
          } else if (
            self.currentWorkspace &&
            self.currentWorkspace.workspace_id
          ) {
            self.$store
              .dispatch("portfolio/_apiFetchPortfolio")
              .then((resp) => {
                self.$store
                  .dispatch("diligence/apiFetchDiligence")
                  .then((response) => {
                    this.isSubmit = false;
                    this.diligenceModal = false;
                    this.$toaster.success("Successfully saved");
                    this.sendDiligenceNotifications(response);
                    this.goToDashboard();
                  });
              });
          } else {
            self.setCurrentWorkspace();
          }
        })
        .catch((err) => {
          this.isSubmit = false;
          this.$toaster.error("Fail to create company");
          console.log(err);
        });
    },
    setCurrentWorkspace() {
      let self = this;
      let allWorkspace = self.myWorkspaces.concat(self.sharedWorkspace);
      let selectedWorkspaceObj = allWorkspace.find(
        (item) => item.workspace_id == self.selectedWorkspaceId
      );
      var defaultPayload = {
        workspace_title: selectedWorkspaceObj.workspace_title,
        workspace_type: selectedWorkspaceObj.workspace_type,
        workspace_id: selectedWorkspaceObj.workspace_id,
        sectors: selectedWorkspaceObj.sectors,
        stages: selectedWorkspaceObj.stages,
      };
      this.$store.commit("workspace/setDefaultPipeline", {
        payload: defaultPayload,
      });
      this.$store.commit("user/workspace_id", {
        workspace_id: self.selectedWorkspaceId,
      });
      self.$store.dispatch("dashboardCoordinates/apiFetchCoordinates");
      self.$store
        .dispatch("workspacePlans/getWorkspacePlanFeatures", {
          workspace_id: self.selectedWorkspaceId,
        })
        .then((plans) => {
          self.$store.dispatch("arbiter/start");
          self.$store
            .dispatch("diligence/apiFetchDiligence")
            .then((response) => {
              self.isSubmit = false;
              self.diligenceModal = false;
              self.$toaster.success("Successfully saved");
              self.sendDiligenceNotifications(response);
              self.goToDashboard();
            });
        });
    },
    fundingRoundOptions(array) {
      const self = this;
      const DATA_STATUS_UNCONFIRMED = "Unconfirmed";
      const DATA_STATUS_UPDATING = "Retrieving";
      const DATA_STATUS_CONFIRMED = "Confirmed";
      return {
        data: array,
        minHeight: 100,
        layout: "fitColumns",
        layoutColumnsOnNewData: true,
        tooltips: true,
        pagination: "local",
        tooltipsHeader: true,
        columns: [
          {
            title: "Funding",
            field: "funding_status",
            sorter: "string",
            //width: 80,
            resizable: true,
          },
          {
            title: "Verified",
            field: "data_status",
            sorter: "string",
            resizable: true,
            //width: "70",
            formatter: function (cell, formatterParams) {
              switch (cell.getData().data_status) {
                case DATA_STATUS_CONFIRMED:
                  return `
                  <span  class="success-data-status">
                    <i class=" nc-icon nc-check-2"></i>
                  </span>`;
                  break;
                case DATA_STATUS_UNCONFIRMED:
                  return `
                  <span  class="warn-data-status">
                  <i class="nc-icon ">!</i>
                  </span>`;
                  break;
                case DATA_STATUS_UPDATING:
                  return `
                  <span  class="normal-data-status">
                  <i class="nc-icon nc-refresh-02 spinner "></i>
                  </span>`;
                  break;
              }
              return "-";
            },
          },
          {
            title: "Round",
            field: "funding_type",
            sorter: "string",
            //width: 100,
            resizable: true,
          },
          {
            title: "Closing Date",
            field: "announced_date",
            sorter: "date",
            // width: 150,
            resizable: true,
            // formatter: function(cell, formatterParams) {
            //   return moment(cell.getData().announced_date).format("MM/DD/YYYY");
            // }
          },
          {
            title: "Total Raised",
            field: "money_raised",
            sorter: "string",
            // width: 150,
            resizable: true,
          },
          {
            title: "Investors",
            field: "number_of_investors",
            sorter: "number",
            //width: 150,
            resizable: true,
          },
          {
            title: "Lead Investors",
            field: "lead_investors",
            sorter: "string",
            //width: 160,
            resizable: true,
          },
          // { title: "Shares", field: "shares", sorter: "string", resizable: true }
        ],
      };
    },
    contacts() {
      let self = this;
      if (self.founders) {
        self.founderArray =
          self.founders.length > 1
            ? [self.founders[0], self.founders[1]]
            : self.founders;
      }
      if (self.investors && self.investors[0] && self.investors[0].list) {
        self.investorArray =
          self.investors[0].list.length > 1
            ? [self.investors[0].list[0], self.investors[0].list[1]]
            : self.investors[0].list;
      }
      if (self.advisors) {
        self.advisorArray =
          self.advisors.length > 1
            ? [self.advisors[0], self.advisors[1]]
            : self.advisors;
      }
      if (self.employees) {
        self.employeeArray =
          self.employees.length > 1
            ? [self.employees[0], self.employees[1]]
            : self.employees;
      }
    },
    contactClick(context, text) {
      if (context == "founder") {
        this.founderArray = [];
        if (text == "more") {
          this.founderArray = JSON.parse(JSON.stringify(this.founders));
        } else {
          this.founderArray =
            this.founders.length > 1
              ? [this.founders[0], this.founders[1]]
              : this.founders;
        }
      }
      if (context == "investor") {
        this.investorArray = [];
        if (text == "more") {
          this.investorArray = JSON.parse(
            JSON.stringify(this.investors[0].list)
          );
        } else {
          this.investorArray =
            this.investors[0].list.length > 1
              ? [this.investors[0].list[0], this.investors[0].list[1]]
              : this.investors[0].list;
        }
      }
      if (context == "advisor") {
        this.advisorArray = [];
        if (text == "more") {
          this.advisorArray = JSON.parse(JSON.stringify(this.advisors));
        } else {
          this.advisorArray =
            this.advisors.length > 1
              ? [this.advisors[0], this.advisors[1]]
              : this.advisors;
        }
      }
      if (context == "employee") {
        this.employeeArray = [];
        if (text == "more") {
          this.employeeArray = JSON.parse(JSON.stringify(this.employees));
        } else {
          this.employeeArray =
            this.employees.length > 1
              ? [this.employees[0], this.employees[1]]
              : this.employees;
        }
      }
    },
    goToDashboard() {
      //this.$store.dispatch("portfolio/_apiFetchPortfolio");
      if (this.$route.query.back) {
        this.$router.push(`/${this.accountId}/workspace`);
      } else {
        this.$router.go(-1);
      }
    },
    mountedMethod() {
      this.showLoader = true;
      if (window.localStorage.getItem("share-portfolio-permalink")) {
        window.localStorage.removeItem("share-portfolio-permalink");
      }
      if (window.localStorage.getItem("share-portfolio-referred")) {
        this.referredBy = window.localStorage.getItem(
          "share-portfolio-referred"
        );
        window.localStorage.removeItem("share-portfolio-referred");
      }
      this.permalink = this.$route.query.permalink;
      this.accountId = this.$route.params.account_id;
      this.workspaceId = this.$route.params.workspace_id;
      let self = this;
      let companyUrl = `${config.API_URL}/public/co/all/${this.permalink}`;
      fetch(companyUrl, {})
        .then((response) => response.json())
        .then((data) => {
          if (data.success && data.success._id) {
            this.showLoader = false;
            this.checkDataCount = 0;
            self.company = data.success;
            let fundingRounds =
              data.success.funding.length > 0
                ? data.success.funding[0].list
                : [];
            self.tabulator = new Tabulator(
              self.$refs.fundingRoundsTable,
              self.fundingRoundOptions(fundingRounds)
            );
            self.founders = data.success.founders;
            self.investors = data.success.investors;
            self.advisors = data.success.advisors;
            self.employees = data.success.employees;
            self.contacts();
          } else {
            setTimeout(() => {
              if (self.checkDataCount <= 4) {
                this.checkDataCount++;
                self.mountedMethod();
              } else {
                self.$toaster.error("Unable to retrieve information");
                self.$router.go(-1);
              }
            }, 5000);
          }
        })
        .catch((err) => {
          console.log("Fail to portfolio data", { err });
        });
    },
    getPeopleImageUrl(item) {
      return item.hasOwnProperty("image_id") && item.image_id.length > 0
        ? `${this.config.CRUNCHBASE_IMAGE_URL}/${item.image_id}`
        : `${
            item.image && item.image.length > 0
              ? item.image
              : "/static/img/face-0.jpg"
          }`;
    },
    showAddCompany() {
      let rolePermissions = this.getCurrentWorkspaceRolePermissions;
      let index = rolePermissions.findIndex((item) => {
        if (item.toLowerCase() == "ADD DILIGENCE COMPANY".toLowerCase()) {
          return item;
        }
      });
      return index >= 0 ? true : false;
    },
  },
  watch: {
    $route(to, from) {
      this.mountedMethod();
    },
    diligenceModal: function (newVal) {
      if (newVal && this.$route.query.workspace_id) {
        this.selectedWorkspaceId = this.$route.query.workspace_id;
      }
    },
  },
};
</script>
<style>
.borderClass {
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #eaeaea;
  border-radius: 2px;
  opacity: 1;
}

.companyDescriptionTitle {
  text-align: left;
  font-size: 14px;
  line-height: 17px;
  font-family: custom-helvetica-bold, roboto;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
  margin-bottom: 10px;
}

.companyDescriptionData {
  text-align: left;
  font-size: 13px;
  line-height: 18px;
  font-family: custom-helvetica, roboto;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
}

.fundingRoundsLayout {
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #eaeaea;
  border-radius: 2px;
  opacity: 1;
  padding-bottom: 15px;
  padding-left: 20px;
  padding-right: 20px;
}

.sharedProfileTabulatorTitle {
  padding: 15px 0px 0px;
  color: #5a5d71;
  font-size: 16px;
  font-family: "custom-helvetica-bold", "roboto";
  line-height: 19px;
  padding-bottom: 15.5px;
  text-align: left;
}

.sharedProfileTabulatorTitleBorderLine {
  border: 0.8px solid #0000000d;
  opacity: 1;
}

.contactsTitle {
  text-align: left;
  font-size: 12px;
  line-height: 15px;
  font-family: custom-helvetica-medium, roboto;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
  padding-bottom: 10px;
}

.contactsName {
  text-align: left;
  font-size: 12px;
  line-height: 30px;
  font-family: custom-helvetica, roboto;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
}

.contactsMore {
  text-align: left;
  text-decoration: underline;
  font-size: 14px;
  line-height: 16px;
  font-family: custom-helvetica, roboto;
  letter-spacing: 0px;
  color: #4338ae;
  opacity: 1;
}

.addtoDiligenceLayout {
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #5445f3;
  border-radius: 5px;
  opacity: 1;
}

.addToDiligenceText {
  text-align: center;
  font-size: 12px;
  line-height: 15px;
  font-family: custom-helvetica-medium, roboto;
  letter-spacing: 0px;
  color: #5445f3;
  opacity: 1;
  padding: 9px;
}

.addToDiligenceMdl .el-dialog .el-dialog__header {
  padding: 20px 40px 0px;
}

.addToDiligenceMdl .el-dialog .el-dialog__header .el-dialog__title {
  line-height: 29px;
  font-size: 24px;
  color: #303133;
}

.addToDiligenceMdl .el-dialog .el-dialog__body {
  padding-top: 22px;
  padding-left: 40px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
  padding-right: 40px;
}
</style>